import { Card, Skeleton } from "@heroui/react";

const LoopOverviewPanelSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Next Meeting */}
      <Card className="shadow-none border">
        <Card.Header className="flex-row gap-2">
          <Skeleton className="size-5 rounded-md" />
          <Skeleton className="h-5 w-32 rounded-lg" />
        </Card.Header>

        <Card.Content className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <Skeleton className="h-5 w-48 rounded-lg" />
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
          <Skeleton className="h-4 w-40 rounded-lg" />
          <div className="flex justify-between items-center mt-2">
            <div className="flex -space-x-2">
              <Skeleton className="size-8 rounded-full" />
              <Skeleton className="size-8 rounded-full" />
            </div>
            <Skeleton className="h-9 w-20 rounded-lg" />
          </div>
        </Card.Content>
      </Card>

      {/* About this loop (accordion) */}
      <Card className="shadow-none border">
        <Card.Content className="flex-row items-center justify-between py-3">
          <Skeleton className="h-5 w-36 rounded-lg" />
          <Skeleton className="size-4 rounded-md" />
        </Card.Content>
      </Card>

      {/* Loop Stats */}
      <Card className="shadow-none border">
        <Card.Header className="flex-row gap-2">
          <Skeleton className="h-5 w-24 rounded-lg" />
        </Card.Header>

        <Card.Content className="grid grid-cols-3 gap-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-start gap-2">
              <Skeleton className="size-9 rounded-full shrink-0" />
              <div className="flex flex-col gap-1.5">
                <Skeleton className="h-5 w-8 rounded-lg" />
                <Skeleton className="h-4 w-16 rounded-lg" />
              </div>
            </div>
          ))}
        </Card.Content>
      </Card>

      {/* Recent Recordings */}
      <Card className="shadow-none border">
        <Card.Header className="flex-row items-center justify-between">
          <Skeleton className="h-5 w-32 rounded-lg" />
          <Skeleton className="h-4 w-14 rounded-lg" />
        </Card.Header>

        <Card.Content className="flex flex-col gap-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center justify-between gap-3 p-2">
              <div className="flex items-center gap-2">
                <Skeleton className="size-9 rounded-full shrink-0" />
                <div className="flex flex-col gap-1.5">
                  <Skeleton className="h-4 w-32 rounded-lg" />
                  <Skeleton className="h-3 w-20 rounded-lg" />
                </div>
              </div>
              <Skeleton className="size-8 rounded-full shrink-0" />
            </div>
          ))}
        </Card.Content>
      </Card>
    </div>
  );
};

export default LoopOverviewPanelSkeleton;